import { render, staticRenderFns } from "./StockLevelConfigurationsAddEdit.vue?vue&type=template&id=ec6d779a&scoped=true&"
import script from "./StockLevelConfigurationsAddEdit.vue?vue&type=script&lang=js&"
export * from "./StockLevelConfigurationsAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./StockLevelConfigurationsAddEdit.vue?vue&type=style&index=0&id=ec6d779a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6d779a",
  null
  
)

export default component.exports